import { CrudField } from "../CrudField";
import { NumberProperty } from "../property-types/NumberProperty";

export class NumberField extends CrudField {
  public static fieldName = "NumberField";
  public static formComponentName: string = "form-number-field";
  protected static readonly defaultPropertyType = NumberProperty;
}
